import { memo } from "react";
import { MenuItem, TextField } from "@mui/material";

export interface IProps {
  field?: any;
  name: string;
  label?: string | null;
  placeholder?: string | null;
  required?: boolean;
  autoFocus?: boolean;
  error?: boolean;
  helperText?: any;
  InputLabelProps?: any;
  inputProps?: any;
  InputProps?: any;
  value?: string | number;
  options?: Array<{ label: string; value: string | number }>;
  disabled?: boolean;
  sx?: any;
  fullWidth?: boolean;
  onChange?: (e: any) => void;
  onFocus?: (e: any) => void;
  onBlur?: (e: any) => void;
}

export default memo(
  ({
    field = {},
    name,
    label = undefined,
    placeholder = "",
    required = false,
    autoFocus = false,
    error = false,
    helperText = "",
    InputLabelProps,
    inputProps,
    InputProps,
    value = undefined,
    options = [],
    disabled = false,
    sx = {},
    fullWidth,
    onChange = undefined,
    onFocus = undefined,
    onBlur = undefined,
  }: IProps) => {
    return (
      <TextField
        select={true}
        {...field}
        name={name}
        label={label}
        placeholder={placeholder}
        required={required}
        autoFocus={autoFocus}
        size="small"
        error={error}
        helperText={helperText}
        onFocus={onFocus}
        onBlur={onBlur}
        InputLabelProps={InputLabelProps}
        inputProps={inputProps}
        InputProps={InputProps}
        disabled={disabled}
        {...(value !== undefined ? { value: value } : {})}
        {...(onChange ? { onChange: onChange } : {})}
        sx={sx}
        fullWidth={fullWidth}
      >
        {options &&
          options.map((o: any, i: number) => (
            <MenuItem key={`${name}-opt-${i}`} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
      </TextField>
    );
  },
);
